<template>
  <div>
    <HistoryLayout>
      <PageHeader slot="page-header" :title="$t('device.history.header')" />
      <HistoryFilter slot="history-filter" :redirectionID="deviceId" />
      <HistoryToolbar slot="history-list-toolbar" />
      <HistoryList slot="history-list" />
    </HistoryLayout>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import { INavigation, store } from '@/store/modules/history/types';
import HistoryFilter from './components/HistoryFilter/HistoryFilter.vue';
import HistoryToolbar from './components/HistoryToolbar/HistoryToolbar.vue';
import HistoryLayout from './components/HistoryLayout/HistoryLayout.vue';
import HistoryList from './components/HistoryList/HistoryList.vue';

@Component({
  components: {
    PageHeader,
    HistoryFilter,
    HistoryLayout,
    HistoryList,
    HistoryToolbar
  }
})
export default class History extends Vue {
  @store.Getter
  private getNavigationConfiguration!: INavigation;

  private deviceId = '';

  private beforeMount() {
    this.deviceId = this.$route?.params?.deviceId;
    if (!this.deviceId) {
      this.getNavigationConfiguration.start = 0;
    }
  }
}
</script>
